// make random string with parameter length
export function addRandomSuffix(name: string, length: number = 5): string {
  const randomString = Math.random()
    .toString(36)
    .substring(2, 2 + length)
  return `${name}_${randomString}`
}
